import { Form, Modal } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import style from "./WalletRequestForm.module.css";

function RequestAmount({
  close,
  value,
  setValue,
  wallet = 0,
  isSupervisorModal = false,
}) {
  return (
    <Modal
      show={true}
      centered={true}
      className={[style.modal, style.requestModal].join(" ")}
    >
      <Modal.Header className="flex-wrap">
        <p>
          <span>موجودی </span>
          <span>{isSupervisorModal ? "اعتبار سرپرستی" : "کیف پول"}</span>
          <span> شما:</span>
        </p>
        <div className="w-100 d-flex justify-content-center align-items-center">
          <h4 className="text-success m-0">{wallet.toLocaleString()}</h4>
          <span className="me-3" style={{ fontSize: 12 }}>
            (ریال)
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>مبلغ درخواستی:</Form.Label>
        <NumericFormat
          suffix=" ريال"
          defaultValue={value}
          onValueChange={({ value }) =>
            setValue(value !== "" ? parseInt(value) : undefined)
          }
          className="form-control"
          thousandSeparator={true}
        />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-primary" onClick={close}>
          تایید
        </button>
        <button onClick={close} className="btn btn-danger">
          خروج
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default RequestAmount;
